import { useState } from "react";
import { IconArrowLink } from "../../../../common/icons/IconArrowLink/IconArrowLink";
import { ABOInfo, PartyInfo, ProfileInfo } from "../../../../services/Profile/profileAPI.types";
import { useAppSelector, RootState } from "../../../../store";
import ABOAddress from "../../ABOAddress/ABOAddress";
import ABOEmail from "../../ABOEmail/ABOEmail";
import ABOPhoneNumber from "../../ABOPhoneNumber/ABOPhoneNumber";
import ABOType from "../../ABOType/ABOType";
import GenderInfo from "../../InfoComponents/GenderInfo/GenderInfo";
import BirthdayInfo from "../../InfoComponents/BirthdayInfo/BirthdayInfo";
import PreferredLanguageInfo from "../../InfoComponents/PreferredLanguageInfo/PreferredLanguageInfo";
import PrimaryTag from "../../TagComponents/PrimaryTag/PrimaryTag";
import ApplicantABOName from "../ApplicantABOName/ApplicantABOName";
import "./ApplicantItem.scss";
import ABOWhatsApp from "../../ABOWhatsApp/ABOWhatsApp";

type Props = {
  aboInfo?: ABOInfo;
  partyInfo?: PartyInfo;
  isExpandable: boolean;
  applicantTrackOnclick: Function;
  profileInfo: Partial<ProfileInfo>;
};

const ApplicantItem = (props: Props) => {
  const { aboInfo, partyInfo, isExpandable, applicantTrackOnclick, profileInfo } = props;
  const [isToggle, setIsToggle] = useState(!partyInfo?.isPrimary);

  const { aboName: nameFormat } = useAppSelector((state: RootState) => state?.boot?.configuration?.profile?.format);
  const { hideWhatsApp } = useAppSelector((state: RootState) => state?.boot?.configuration);

  const iconArrowLinkOnClick = () => {
    setIsToggle(!isToggle);
  };

  const boot = useAppSelector((state: RootState) => state.boot);

  const { showBirthday, showLanguage, showGender } = profileInfo;
  const { showPartyId = true } = boot?.configuration?.profile?.party || {};

  if (partyInfo) {
    const {
      partyId,
      isPrimary,
      displayName,
      localeDisplayName,
      localeName,
      latinName,
      isoBirthdate,
      gender,
      preferredLanguageCode,
      emailAddresses,
      phoneNumbers,
      addresses,
      whatsApp,
    } = partyInfo;
    const { privacyFlag = false, businessNatureCode = 0, registrationChannelCd = "" } = aboInfo || {};
    const { email } = emailAddresses?.[0] || {};
    const { displayNumber } = phoneNumbers?.[0] || {};
    const { addressLines, municipality, region, postalCode, country, type } = addresses?.[0] || {};
    const { ecommAddr: whatsAppContactNumber } = whatsApp?.[0] || {};

    return (
      <div className="leaf-applicant-item">
        <div className="leaf-applicant-item__header">
          <div className="leaf-applicant-item__header--tag">
            <PrimaryTag isPrimary={isPrimary} />
          </div>

          <div className="leaf-applicant-item__header--details">
            <ApplicantABOName
              displayName={displayName}
              localeDisplayName={localeDisplayName}
              localeName={localeName}
              latinName={latinName}
              privacyFlag={privacyFlag}
              preferredLanguageCode={preferredLanguageCode}
              nameFormat={nameFormat}
            ></ApplicantABOName>
            {showPartyId && <div className="leaf-applicant-item__header--abo-number">{partyId}</div>}
          </div>

          {isExpandable === true && (
            <>
              <div className="leaf-applicant-item__header--type">
                <ABOType businessNature={businessNatureCode} registrationChannelCd={registrationChannelCd} />
                <div
                  className={`leaf-applicant-item__header__arrow${isToggle === false ? "--down" : ""}`}
                  onClick={iconArrowLinkOnClick}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      iconArrowLinkOnClick();
                    }
                  }}
                  tabIndex={0}
                  role="button"
                >
                  <IconArrowLink />
                </div>
              </div>
            </>
          )}
        </div>

        <div
          className={`leaf-applicant-item__content ${
            isToggle && isExpandable && "leaf-applicant-item__content--toggled"
          }`}
        >
          <ABOPhoneNumber
            primaryNumber={displayNumber}
            privacyFlag={privacyFlag}
            applicantTrackOnclick={applicantTrackOnclick}
          />
          <ABOEmail email={email} privacyFlag={privacyFlag} applicantTrackOnclick={applicantTrackOnclick}></ABOEmail>

          {whatsAppContactNumber && !hideWhatsApp ? (
            <ABOWhatsApp
              whatsAppContactNumber={whatsAppContactNumber}
              privacyFlag={privacyFlag}
              applicantTrackOnclick={applicantTrackOnclick}
            />
          ) : null}

          {isExpandable === true && (
            <>
              <ABOAddress
                addresses={{
                  addressLines,
                  municipality,
                  region,
                  postalCode,
                  country,
                  type,
                }}
                privacyFlag={privacyFlag}
                applicantTrackOnclick={applicantTrackOnclick}
              />
              <div className="leaf-applicant-item__line"></div>
              <PreferredLanguageInfo
                isoLanguage={preferredLanguageCode}
                privacyFlag={privacyFlag}
                show={showLanguage}
              />
              <GenderInfo gender={gender} privacyFlag={privacyFlag} show={showGender} />
              <BirthdayInfo date={isoBirthdate} privacyFlag={privacyFlag} show={showBirthday} />
            </>
          )}
        </div>
      </div>
    );
  }

  return <></>;
};

export default ApplicantItem;
